import CommonNaviBar from '../../common/component/NaviBar'
import AWSAPI from '../../common/AWSAPI'
import EstimationStore from '../libs/EstimationStore'

class NaviBar extends CommonNaviBar {
  constructor (props) {
    super(props)
    this.userRole = 'companyUser'
    this.userRoleUrl = 'company_user'
    this.naviSetting = [
      {
        dropdownToggle: 'マイページ',
        dropdownMenu: [
          {
            title: 'Home',
            url: '/company_user'
          },
          {
            title: 'お知らせ',
            url: '/company_user/information'
          },
          {
            title: '共有ファイル',
            url: '/company_user/shared_files'
          }
        ]
      },
      {
        dropdownToggle: '見積書',
        dropdownMenu: [
          {
            title: '見積書作成',
            url: '/company_user/estimation/real/add'
          },
          {
            title: '見積書一覧',
            url: '/company_user/estimation/real'
          }
        ]
      },
      {
        dropdownToggle: '雛型',
        dropdownMenu: [
          {
            title: '雛型作成',
            url: '/company_user/estimation/template/add'
          },
          {
            title: '雛型一覧',
            url: '/company_user/estimation/template'
          }
        ]
      },
      {
        dropdownToggle: '個人設定',
        dropdownMenu: [
          {
            title: 'パスワード変更',
            url: '/company_user/password_change'
          },
          {
            title: 'メールアドレス変更',
            url: '/company_user/email_change'
          },
          {
            title: '通知受信可否設定変更',
            url: '/company_user/notification_setting_change'
          }
        ]
      },
      {
        dropdownToggle: 'アンケート',
        dropdownMenu: [
          {
            title: 'アンケート回答',
            url: '/company_user/survey_answer'
          }
        ]
      },
    ]
  }
  logout (e) {
    e.preventDefault()
    AWSAPI.logout(this.userRole)
    EstimationStore.clearAllStorage()
    window.location.href = '/' + this.userRoleUrl + '/login' // あえてリロード
  }
}

export default NaviBar



// WEBPACK FOOTER //
// ./src/company_user/components/NaviBar.js